import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@mui/material";

export default function HypothesisChart({ hypothesisInUse }) {
    const options = {
        chart: {
            type: "pie",
            animation: {
                duration: 500,
            },
        },
        title: {
            text: `${
                hypothesisInUse?.unresolved?.length +
                hypothesisInUse?.validated?.length +
                hypothesisInUse?.invalidated?.length
            } Hypotheses`,
        },
        plotOptions: {
            pie: {
                innerSize: "80%",
                dataLabels: {
                    enabled: true,
                },
                animation: {
                    duration: 500,
                },
            },
        },
        series: [
            {
                name: "",
                data: [
                    {
                        name: `${hypothesisInUse?.unresolved?.length} Unresolved`,
                        y: hypothesisInUse?.unresolved?.length,
                    },
                    {
                        name: `${hypothesisInUse?.validated?.length} Validated`,
                        y: hypothesisInUse?.validated?.length,
                    },
                    {
                        name: `${hypothesisInUse?.invalidated?.length} Invalidated`,
                        y: hypothesisInUse?.invalidated?.length,
                    },
                ],
                animation: {
                    duration: 500,
                },
            },
        ],
        colors: ["#D4D4D4", "#BFE3C0", "#F1ADAC"],
    };

    return (
        <Box sx={{ overflow: "auto" }}>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </Box>
    );
}
